import { useEffect } from "react"
import { getLocalAppData } from "../utils/getappDataLocal"

const useApp = () => {
    const { appName, favicon } = getLocalAppData();
    const setAppTitle = () => {
        const publicUrl = `${window.location.origin}${window.location.pathname.split("/").slice(0, 2).join("/")}`;
        const faviconElement = document.querySelector('link[rel="icon"]');

        // Set the favicon if the element exists or fallback to the default.
        if (faviconElement) {
            faviconElement.href = favicon || `${publicUrl}/favicon.ico`;
        }

        // Set the document title.
        document.title = appName || "Logiks Chat";
    };

    useEffect(() => {
        setAppTitle();
    }, [appName, favicon]); // Dependencies: appName and favicon
}

export default useApp